import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EvidFunction, EvidIoControl, EvidVid} from '@catcore/types/io-control-matrix-models';

const INPUT_MODE_MOMENTARY = 'MOMENTARY';

@Component({
  selector: 'cat-switch-logic-select',
  templateUrl: './switch-logic-select.component.html',
})
export class SwitchLogicSelectComponent {

  @Input() public vid: EvidVid;

  @Input() public ioControl: EvidIoControl;

  @Input() private evidFunction: EvidFunction;

  @Output() private changeIoControl = new EventEmitter<EvidIoControl>();

  public isMomentary(): boolean {
    if (this.evidFunction.input_mode) {

      return this.evidFunction.input_mode === INPUT_MODE_MOMENTARY;
    }

    return false;
  }

  public changeInputState() {
    if (!this.isMomentary()) {
      return;
    }

    if (this.ioControl.switch_logic) {
      this.changeIoControl.emit(this.ioControl);
    }
  }

  public changeSwitchLogic() {
    if (this.isMomentary() && !this.ioControl.input_state) {
      return;
    }

    this.changeIoControl.emit(this.ioControl);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/components/switch-logic-select/switch-logic-select.component.ts